import Status from './status';
/**
 * Retrieves array of strings with list of resources from the apiData in pageprops
 * @param apiDataPageProps
 * If retrieved from mdx format is string: "TabbedRates:9,TabbedRates:8"
 * If retrieved from memory in buildr format is object: [{key: 1, value: "TabbedRates:9"},{key: 1, value: "TabbedRates:8"}}]
 * @returns string array such as: ["TabbedRates:9", "TabbedRates:8"] or empty array
 */
export function getApiDataItems(apiDataPageProps): string[] {
    if (typeof apiDataPageProps === 'string' && apiDataPageProps !== '') {
        return apiDataPageProps.split(',');
    } else {
        return apiDataPageProps ? apiDataPageProps.map(({value}) => value) : [];
    }
}

/**
 * Recursively lookup field in data object
 * @param object ex: {a: {b: {c: "15"}}}
 * @param pathSections ex: ['a', 'b', 'c']
 * @returns found value in object if path is valid, otherwise returns undefined
 */
export function getInObject(object, pathSections: string[]): string|null|undefined {
    if (object === Status.LOADING) return '';
    if (!object || pathSections.length === 0) return object;
    return getInObject(object[pathSections[0]], pathSections.slice(1));
}